import React, { useState } from 'react';
import PullToRefresh from '../components/PullToRefresh';

export default function PullToRefreshTest() {
  const [refreshCount, setRefreshCount] = useState(0);
  const [lastRefreshTime, setLastRefreshTime] = useState(null);

  const handleRefresh = async () => {
    console.log('Refresh triggered!');
    setRefreshCount(prev => prev + 1);
    setLastRefreshTime(new Date().toLocaleTimeString());
    
    // Simulate some async operation
    await new Promise(resolve => setTimeout(resolve, 1000));
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f1f5f9' }}>
      <PullToRefresh onRefresh={handleRefresh} debug={true}>
        <div style={{ 
          padding: '20px',
          textAlign: 'center',
          fontFamily: 'system-ui, sans-serif'
        }}>
          <h1 style={{ 
            fontSize: '32px', 
            color: '#1e293b',
            marginBottom: '20px'
          }}>
            Pull-to-Refresh Test
          </h1>
          
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            marginBottom: '20px'
          }}>
            <h2 style={{ color: '#0f766e', marginBottom: '15px' }}>Instructions:</h2>
            <p style={{ marginBottom: '10px' }}>
              1. Make sure you're at the top of the page
            </p>
            <p style={{ marginBottom: '10px' }}>
              2. On mobile: Touch and drag down from the top
            </p>
            <p style={{ marginBottom: '10px' }}>
              3. Watch for rotating words: OUTWIT, OUTPLAY, OUTLAST
            </p>
            <p>
              4. Release when you see the words to trigger refresh
            </p>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            marginBottom: '20px'
          }}>
            <h3 style={{ color: '#1e293b', marginBottom: '15px' }}>Results:</h3>
            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
              Refresh Count: <strong style={{ color: '#0f766e' }}>{refreshCount}</strong>
            </p>
            <p style={{ fontSize: '16px' }}>
              Last Refresh: <strong>{lastRefreshTime || 'Never'}</strong>
            </p>
          </div>

          <div style={{
            backgroundColor: '#fef3c7',
            padding: '20px',
            borderRadius: '8px',
            border: '1px solid #f59e0b'
          }}>
            <h4 style={{ color: '#92400e', marginBottom: '10px' }}>Debug Info:</h4>
            <p style={{ fontSize: '14px', color: '#92400e' }}>
              Look for the red debug box in the top-right corner.
              Check browser console for touch event logs.
            </p>
          </div>

          {/* Add some content to make scrolling possible */}
          <div style={{ marginTop: '50px', color: '#64748b' }}>
            <h3>Scroll Test Content</h3>
            {Array.from({ length: 20 }, (_, i) => (
              <p key={i} style={{ margin: '10px 0' }}>
                This is line {i + 1} - scroll down to test that pull-to-refresh only works at the top.
              </p>
            ))}
          </div>
        </div>
      </PullToRefresh>
    </div>
  );
}